import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { DatePicker } from '@blueprintjs/datetime';
import { Popover } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { systemTimezoneAbbreviated } from '../helpers/time';

@observer
class DateTimeInput extends React.Component {
  
  @observable value = moment();

  componentDidMount(){
    this.value = this.props.defaultValue || moment();
  }

  // Follow defaultValue only when it points at a different time. Assigning
  // `value` re-renders this observer, so doing it on every update (with a new
  // moment() when there's no defaultValue) looped until React gave up.
  componentDidUpdate(prevProps){
    const next = this.props.defaultValue;
    const prev = prevProps.defaultValue;
    const changed = next
      ? !prev || moment(next).valueOf() !== moment(prev).valueOf()
      : Boolean(prev);
    if (changed) {
      this.value = next || moment();
    }
  }

  onChange = (selectedDate, isUserChange) => {
    if(!selectedDate){
      return
    }
    if(this.props.onChange){
      this.props.onChange(selectedDate, isUserChange);
    }
    this.value = moment(selectedDate);
  }

  datePicker() {
    return (
      <React.Fragment >
        <DatePicker
          value={ this.value.toDate() }
          onChange={this.onChange.bind(this)}
          timePrecision={'minute'}
          timePickerProps={{ useAmPm: true }}
          minDate={this.props.minDate ? this.props.minDate.toDate() : moment().subtract(20, 'years').toDate() }
          maxDate={this.props.maxDate ? this.props.maxDate.toDate() : moment().add(365, 'days').toDate() }
        />
      </React.Fragment>
    )
  }

  render() {
    let {
			bookingStatus,
			disabled
		} = this.props;
    // Locked: a confirmed booking, or the caller says so. The text box only
    // opens the picker (typing never changed it), so it's read-only, and
    // disabled when locked so it looks and behaves like the other locked fields.
    const locked = Boolean(disabled) || bookingStatus === 'confirmed';
    return (
      <Popover
        minimal={false}
        disabled={locked}
        position={'right'}
        content={this.datePicker.bind(this)()} >
        <input 
          className="bp3-input bp3-fill"
          type="text"
          dir="auto"
          readOnly={true}
          disabled={locked}
          value={this.props.format ? this.value.format(this.props.format) : this.value.format('llll') + " " + systemTimezoneAbbreviated() }
          placeholder={this.props.placeholder}
          onChange={() => {}}
        />
      </Popover>
    )
  }
}

DateTimeInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  bookingStatus: PropTypes.string,
  // A moment format for the text box (default: long date, time and time zone).
  format: PropTypes.string,
}

export default DateTimeInput;